import truncate from 'lodash/truncate'

export default (value, { length = 24, separator = ' ', ...args } = {}) => truncate(value, { length, separator, ...args })
